import React from "react";
import { PurchaseStatus } from "../data/api";
import { useHistory } from "react-router-dom";
import { Container } from "../components";
import { useMediaQuery } from "../hooks";
import { Hidden } from "./hidden";
import { Spacer } from "./spacer";
import { useOnboardingPortalFeatureFlag } from "../core/splitio";
import { useI18n } from "../lib/i18n/i18n_provider";
import styles from "./portal_onboarding.module.css";

interface PortalOnboardingProps {
  email: string;
  partnerId: string;
  partnerSlug: string;
  purchaseStatus: PurchaseStatus;
}

const PortalOnboarding = (props: PortalOnboardingProps) => {
  const history = useHistory();
  const { email, partnerId, partnerSlug, purchaseStatus } = props;
  const { hasPortalAccount, purchasedMultiPass, purchasedMembershipPortal } =
    purchaseStatus;
  const isNew = !hasPortalAccount;
  const mq = useMediaQuery();
  const isMobile = mq.device === "mobile";
  const ffEnabled = useOnboardingPortalFeatureFlag(partnerId);
  const { fbt } = useI18n();

  if (!ffEnabled || purchaseStatus.purchasedMembershipWoPortal) {
    return null;
  }

  const handlePortalRedirect = () => {
    const encodedEmail = encodeURIComponent(email);

    let url = `/portal/${partnerSlug}`;

    if (isNew) {
      url = `/portal/auth/signup?partnerSlug=${partnerSlug}&email=${encodedEmail}&screen=signup`;
    } else {
      url = `${url}?email=${encodedEmail}&screen=signUp`;
    }

    history.push(url);
  };
  const title = isNew ? fbt("Activate your member portal") : "";
  let message;
  let buttonLabel = isNew ? fbt("Set my password") : fbt("Login");

  if (isNew) {
    message = fbt(
      "To get the most out of your Coworking membership, you’ll need to activate your member portal. To get started, click the button below to set your password and login."
    );
  } else {
    if (!purchasedMembershipPortal) {
      return null;
    }

    if (purchasedMultiPass) {
      message = fbt(
        "To access your member portal, login with the same credentials you used for your multi passes."
      );
    } else {
      message = fbt(
        "Login to your member portal to access your new membership."
      );
    }
  }

  return (
    <Container
      paddingHorizontal={24}
      paddingVertical={24}
      className={styles.confirmPortalBanner}
      backgroundColor="#432ADC14"
      borderRadius={8}
    >
      {title && <strong>{title}</strong>}
      <div>
        {isNew ? (
          <div>
            <Spacer size={4} />
            <div>{message}</div>
            <Spacer size={24} />
            <button
              onClick={handlePortalRedirect}
              className="btn btn-outline-primary"
              style={{ width: isMobile ? "100%" : "auto" }}
            >
              {buttonLabel}
            </button>
          </div>
        ) : (
          <div
            style={{
              display: isMobile ? "block" : "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ paddingRight: "24px" }}>{message}</div>
            <div>
              <Hidden md>
                <Spacer size={24} />
              </Hidden>
              <button
                onClick={handlePortalRedirect}
                className="btn btn-primary"
                style={{ width: isMobile ? "100%" : "auto" }}
              >
                {buttonLabel}
              </button>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export { PortalOnboarding };
